import Html from "../../../../_core/ts/libs/html";

class Elections {

    constructor(
        private html: Html
    ) { }

    load(boxPath: string): void {
        this.html.fetchText(boxPath)
            .then((html: string) => {                
                const electionsBox = this.html.q('#elections-box');
                if (!electionsBox) { return; }

                this.html.writeHTML(electionsBox, html);
                this.onStart();
        });
    }

    onPartyClick(div: HTMLElement): void {
        div.classList.toggle('elections-item--active');
        this.updateInfographic();
    }

    onResetClick(): void {
        this.html.removeClass('.elections-item--active', 'elections-item--active');
        this.updateInfographic();
    }

    onStart(): void {
        let seatColors: string[] = [];

        for (const selectedItem of this.html.qAll('.elections-item')) {
            const mandates = parseInt(selectedItem.getAttribute('data-mandates') || '0');
            const color = selectedItem.getAttribute('data-color') || 'CFCFCE';

            for (let i = 0; i < mandates; i++) seatColors.push(color);
        }
        this.colorSeats(seatColors);
    }


    updateInfographic(): void {
        let textDiv = this.html.q('#is-selected-majority');
        if (!textDiv) return;

        let count = 0;
        let seatColors: string[] = [];

        for (const selectedItem of this.html.qAll('.elections-item--active')) {
            const mandates = parseInt(selectedItem.getAttribute('data-mandates') || '0');
            const color = selectedItem.getAttribute('data-color') || 'CFCFCE';

            count += mandates;
            for (let i = 0; i < mandates; i++) seatColors.push(color);
        }

        const box = this.html.q('#is-selected-majority')
        const boxMobile = this.html.q('#is-selected-majority-mobile');
        if (!box || !boxMobile) return;

        this.html.toggleClassIf('.electons-reset-button', count === 0, 'opacity-0');
        this.html.toggleClassIf('.electons-reset-button-cursor', count === 0, 'cursor-default');

        if (count === 0) {
            this.html.removeClass(box, 'md:flex');

            this.html.removeClass(boxMobile, 'md:hidden');
            this.html.addClass(boxMobile, 'hidden');

            this.onStart();
            return;
        }

        this.html.addClass(box, 'md:flex');
        
        this.html.removeClass(boxMobile, 'hidden');
        this.html.addClass(boxMobile, 'md:hidden');

        const warning = this.html.q('#is-selected-majority-warning');
        const check = this.html.q('#is-selected-majority-check');
        const text = this.html.q('#is-selected-majority-text');

        const warningMobile = this.html.q('#is-selected-majority-warning-mobile');
        const checkMobile = this.html.q('#is-selected-majority-check-mobile');
        const textMobile = this.html.q('#is-selected-majority-text-mobile');

        if (!warning || !check || !text || !warningMobile || !checkMobile || !textMobile) return;
        const hasMajority = count >= 46;

        this.html.toggleClassIf(warning,hasMajority, 'hidden',);
        this.html.toggleClassIf(check, !hasMajority, 'hidden',);

        this.html.toggleClassIf(warningMobile, hasMajority, 'hidden',);
        this.html.toggleClassIf(checkMobile, !hasMajority, 'hidden',);

        this.html.toggleClassIf(box, !hasMajority, 'text-black',);
        this.html.toggleClassIf(box, !hasMajority, 'dark:text-white',);
        this.html.toggleClassIf(box, hasMajority, 'text-[#22A06B]',);

        this.html.toggleClassIf(boxMobile, !hasMajority, 'text-black',);
        this.html.toggleClassIf(boxMobile, !hasMajority, 'dark:text-white',);
        this.html.toggleClassIf(boxMobile, hasMajority, 'text-[#22A06B]',);

        this.html.writeHTML(text,hasMajority
            ? `Izbrana koalicija ima večino. (${count}/90)`
            : `Izbrana koalicija nima večine. (${count}/90)`);

        this.html.writeHTML(textMobile, hasMajority
            ? `Ima večino. (${count}/90)`
            : `Nima večine. (${count}/90)`);


        this.colorSeats(seatColors);

    }

    colorSeats(seats: string[]): void {
        for (let i = 0; i < 90; i++) {
            this.html.q(`#parliament-seat-${i}`)?.setAttribute('fill', `#${seats[i] ?? 'CFCFCE'}`);
        }
    }
}

export default Elections;